module.exports = __webpack_public_path__ + "assets/BackBT-8b07a8.svg";